import { deleteAsset, unlinkAsset, submitForm } from './effects'

export const UPDATE_PROPS = 'UPDATE_PROPS'
export const GO_TO_ADD_ASSET = 'GO_TO_ADD_ASSET'
export const SET_TITLE = 'SET_TITLE'
export const BACK = 'SET_TITLE'
export const DELETE_ASSET = 'DELETE_ASSET'
export const UNLINK_ASSET = 'UNLINK_ASSET'
export const UPDATE_ASSET = 'UPDATE_ASSET'
export const UPDATE_SUB_ASSET = 'UPDATE_SUB_ASSET'
export const SET_ASSET_TYPE_TO_CREATE = 'SET_ASSET_TYPE_TO_CREATE'
export const CONFIRM_DELETE = 'CONFIRM_DELETE'
export const CONFIRM_UNLINK = 'CONFIRM_UNLINK'
export const SUBMIT_FORM = 'SUBMIT_FORM'
export const GO_TO_INDEX = 'GO_TO_INDEX'
export const LOADING = 'LOADING'
export const MUTATION_FAILED = 'MUTATION_FAILED'
export const SET_ASSET_VIEW = 'SET_ASSET_VIEW'

export const actionCreators = (dispatch, state) => ({
  updateProps: (props) =>
    dispatch({
      type: UPDATE_PROPS,
      payload: { props }
    }),
  goToIndex: () =>
    dispatch({
      type: GO_TO_INDEX
    }),
  goToAddAsset: () =>
    dispatch({
      type: GO_TO_ADD_ASSET
    }),
  back: () =>
    dispatch({
      type: BACK
    }),
  deleteAsset: (asset) => () =>
    dispatch({
      type: asset?.id ? DELETE_ASSET : GO_TO_INDEX,
      payload: { asset, scrollTop: window.scrollY }
    }),
  unlinkAsset: (asset) => () =>
    dispatch({
      type: UNLINK_ASSET,
      payload: { asset, scrollTop: window.scrollY }
    }),
  updateAsset: (asset) => () =>
    dispatch({
      type: UPDATE_ASSET,
      payload: { asset }
    }),
  setAssetTypeToCreate: (assetType) => () =>
    dispatch({
      type: SET_ASSET_TYPE_TO_CREATE,
      payload: { assetType }
    }),
  setAssetView: (assetView) => {
    dispatch({
      type: SET_ASSET_VIEW,
      payload: { assetView }
    })
  },

  // async actions
  confirmDelete: async () => {
    dispatch({
      type: LOADING
    })
    try {
      await deleteAsset(state)
      dispatch({ type: CONFIRM_DELETE })
    } catch (error) {
      dispatch({ type: MUTATION_FAILED, payload: { error: error.message || 'Unable to delete this asset. Please try again.' } })
    }
  },
  confirmUnlink: async (mode = 'permanent') => {
    dispatch({
      type: LOADING
    })
    try {
      await unlinkAsset(state, mode)
      dispatch({ type: CONFIRM_UNLINK })
    } catch (error) {
      dispatch({ type: MUTATION_FAILED, payload: { error: error.message || 'Unable to unlink this asset. Please try again.' } })
    }
  },
  submit: async (formValues) => {
    dispatch({
      type: LOADING
    })
    try {
      await submitForm(state, formValues)
      dispatch({ type: SUBMIT_FORM })
    } catch (error) {
      dispatch({ type: MUTATION_FAILED, payload: { error: error.message || 'Unable to save this asset. Please try again.' } })
    }
  }
})
